__turbopack_context__.v({
  "backgroundCircle": "DBfToq_backgroundCircle",
  "characterCountCircle": "DBfToq_characterCountCircle",
  "characterCountCircle-enter": "DBfToq_characterCountCircle-enter",
  "characterCountCircle-enter-active": "DBfToq_characterCountCircle-enter-active",
  "characterCountCircle-exit": "DBfToq_characterCountCircle-exit",
  "characterCountCircle-exit-active": "DBfToq_characterCountCircle-exit-active",
  "characterCountContainer": "DBfToq_characterCountContainer",
  "overLimit": "DBfToq_overLimit",
  "progressCircle": "DBfToq_progressCircle",
  "warning": "DBfToq_warning",
});
